<template>
  <div class="formBox userInfo">
    <div class="formTitle toCapitalize notranslate">{{locale.booker_information}}</div>
    <!-- 예약자 정보:: 이름 -->
    <div class="notranslate mb15">
      <div class="formGroup isRequired mt15">
        <label class="label toCapitalize">{{locale.first_name}}</label>
        <input type="text" class="input" v-model="firstName" @keyup="setUserInfo('firstName', $event)" required>
      </div>
      <div class="formGroup isRequired mt15">
        <label class="label toCapitalize">{{locale.last_name}}</label>
        <input type="text" class="input" v-model="lastName" @keyup="setUserInfo('lastName', $event)" required>
      </div>
    </div>
    <!-- //예약자 정보:: 이름 -->
    <!-- 예약자 정보 선택 입력 -->
    <div v-if="info.bookerTelOrEmail" class="mb5">
      <p class="formTitle toCapitalize notranslate mt30 mb5">{{ locale.message_select_phone_or_email }}</p>
      <div class="formTabs">
        <label for="select_info_method_tel" class="tab" :class="{isActive: selectInfoMethod === 'tel'}">
          <input type="radio" name="select_info_method" id="select_info_method_tel" value="tel" v-model="selectInfoMethod">
          {{ locale.telephone }}
        </label>
        <label for="select_info_method_email" class="tab" :class="{isActive: selectInfoMethod === 'email'}">
          <input type="radio" name="select_info_method" id="select_info_method_email" value="email" v-model="selectInfoMethod">
          {{ locale.email }}
        </label>
      </div>
    </div>
    <!-- //예약자 정보 선택 입력 -->
    <!-- 예약자 정보:: 연락처 -->
    <div v-if="info.bookerTelOrEmail ? selectInfoMethod === 'tel' : info.bookerTel" class="formGroup isRequired notranslate telInputWithSearch">
      <label v-if="info.bookerTel" class="label toCapitalize">{{locale.telephone}}</label>
      <div v-show="openCountry" class="searchCountry">
        <input
          type="text"
          class="input"
          placeholder="country name or code"
          ref="searchInput"
          v-model="searchCountry"
          @focus.stop
          @click.stop
          @keyup.enter="setSearchCountry" />
        <button type="button" class="btn btnSearch" @click.stop="setSearchCountry">
          {{locale.search}}
        </button>
      </div>
      <vue-tel-input
        class="telInput input"
        ref="telInput"
        v-model="phone"
        :mode="'national'"
        :autoDefaultCountry="true"
        :preferredCountries="filteredCountry"
        :validCharactersOnly="true"
        @input="inputTel"
        @open="toggleCountry(true)"
        @close="toggleCountry(false)"></vue-tel-input>
    </div>
    <!-- //예약자 정보:: 연락처 -->
    <!-- 예약자 정보:: 이메일 -->
    <div v-if="info.bookerTelOrEmail ? selectInfoMethod === 'email' : info.bookerEmail" class="formGroup isRequired notranslate" :class="{mt15: info.bookerEmail}">
      <label v-if="info.bookerEmail" class="label toCapitalize">{{locale.email}}</label>
      <input type="email" class="input" placeholder="example@email.com" v-model="email" @keyup="setUserInfo('email', $event)" required>
    </div>
    <!-- //예약자 정보:: 이메일 -->
  </div>
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import Summary from '@/components/Reservation/Summary'
import SeatMap from '@/components/Reservation/SeatMap'

export default {
  name: 'ReservationFormUserInfo',
  props: [
    'lang',
    'ln',
    'locale',
    'info',
    'roomKey',
    'rid',
    'guestUserInfo',
    'isPublic'
  ],
  components: {
    Summary,
    SeatMap
  },
  computed: {
    filteredCountry () {
      const word = regExp.replaceAllEmpty(this.searchCountry).toLowerCase()
      const findCountry = this.countryList.filter(x => {
        const iso2 = regExp.replaceAllEmpty(x.iso2).toLowerCase().includes(word)
        const dialCode = regExp.replaceAllEmpty(`+${x.dialCode}`).toLowerCase().includes(word)
        const name = regExp.replaceAllEmpty(x.name).toLowerCase().includes(word)
        return word.length > 0 && (iso2 || dialCode || name)
      }).map(x => x.iso2)
      return findCountry
    }
  },
  watch: {
    selectInfoMethod (method) {
      this.phone = ''
      this.email = ''
      this.setUserInfo('phone')
      this.setUserInfo('email')
    }
  },
  mounted () {
    this.$nextTick(() => {
      const guestUserInfo = this.guestUserInfo && this.guestUserInfo.info
      const infoList = [
        'firstName',
        'lastName',
        'phone',
        'email'
      ]
      this.countryList = this.$refs.telInput ? this.$refs.telInput.allCountries : []
      if (guestUserInfo) {
        for (let i = 0; i < infoList.length; i++) {
          const info = infoList[i]
          const inputInfo = guestUserInfo[info]
          if (inputInfo) {
            this[info] = inputInfo || ''
            this.setUserInfo(info)
          }
        }
      }
    })
  },
  data () {
    return {
      openCountry: false,
      searchCountry: '',
      countryList: [],
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      validatePhone: {},
      selectInfoMethod: 'tel'
    }
  },
  methods: {
    toggleCountry (isOpen) {
      this.openCountry = isOpen
      if (isOpen) {
        const findInput = this.$refs.searchInput
        if (findInput) {
          this.$nextTick(() => findInput.focus())
        }
      }
    },
    inputTel (number, telObj) {
      this.validatePhone = telObj
      this.phone = telObj.number || ''
      this.setUserInfo('phone')
    },
    setSearchCountry () {
      const value = this.$refs.searchInput.value
      this.searchCountry = value
      this.setUserInfo('phone')
    },
    setUserInfo (target, e) {
      const info = e && e.target ? e.target.value : this[target]
      this.$emit('setUserInfo', { target: target, info: info, phoneIsValid: this.validatePhone.valid })
    }
  }
}
</script>
